import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button, Input, Checkbox } from "antd";
import { TiUser } from "react-icons/ti";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import {
  addPengembalianData,
  initFilterInput,
  renderColumns,
} from "./constants";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import PreviewImage from "../../../components/common/PreviewImage/PreviewImage";
import CustomTable from "../../../components/common/Table/CustomTable";
import Title from "../../../components/common/Title/Title";
import moment from "moment";
import DatePicker from "react-datepicker";
import { IoCalendarOutline } from "react-icons/io5";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import { convertPengembalianTerjadwal } from "../helpers/convertPengembalianTerjadwal";
import Select from "react-select";
import AddUpload from "../components/TandaiSelesai";
import CustomDatePicker from "../helpers/CustomDatePicker";
import ErrorDiv from "../../../components/helpers/ErrorDiv";

export default function PengembalianBarang() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [id, setId] = useState("");
  const [dateValue, setDateValue] = useState([]);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUbah, setModalUbah] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [codeGadai, setCodeGadai] = useState("");
  const [namaNasabah, setNamaNasabah] = useState();
  const [notelpNasabah, setNotelpNasabah] = useState();
  const [kondisi, setKondisi] = useState();
  const [noImei, setNoImei] = useState();
  const [tanggalKirim, setTanggalKirim] = useState();
  const [waktuKirim, setWaktuKirim] = useState();
  const [alamatKirim, setAlamatKirim] = useState();
  const [kurir, setKurir] = useState();
  const [sbg, setSbg] = useState();

  const [barangJaminan, setBarangJaminan] = useState();
  const [date, setDate] = useState();
  const [outletName, setOutletName] = useState();
  const [kurirList, setKurirList] = useState([]);

  // image
  const [errors, setErrors] = useState({});
  const [sbgImg, setSbgImg] = useState([]);
  const [sbgImg2, setSbgImg2] = useState([]);
  const [ktpNasabahImg, setktpNasabahImg] = useState([]);
  const [ktpPenerimaImg, setktpPenerimaImg] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [addData, setAddData] = useState(addPengembalianData);

  useEffect(() => {
    getData();
    getEmployee();
  }, [filterInput]);

    const getEmployee = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delivery/master-data`;
        AxiosCustomGet(
            url,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`,
            }),
            (response) => {
                setLoading(false);
                setKurirList(
                    response.data.data.couriers.map((item) => ({
                        value: item.id,
                        label: `${item.first_name} ${item.last_name}`,
                        outlet: item.outlet.name
                        // ...item,
                    }))
                );
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delivery-scheduled`;
    let params = {
      search: filterInput.searchName,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize) || 0,
      start_date: filterInput.transactionStartDate,
      end_date: filterInput.transactionEndDate,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };
    console.log(params);

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        let data = response.data.data;
        setRecords(convertPengembalianTerjadwal(data.items, handleOpenPreview));
        setTotalRecords(data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const reset = () => {
    //
  };

  const handleOpenPreview = (src) => () => {
    setModalAdd(false);
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleSubmit = () => {
    let data = {
      gadai_id: id,
      employee_id: kurir?.id,
      address: alamatKirim,
      delivery_date: date,
    };

    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delivery/confirm`;
    httpclient
      .POST(url, data)
      .then((response) => {
        console.log(response);
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        getData();
        setModalUbah(false);
        handleCloseModal();
      })
      .catch((error) => {
        if (error.response) {
          setSubmitting(false);
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
          setSubmitting(false);
        }
      });
  };
  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setAddData((prev) => ({
          ...prev,
          sbg: type === "sbg" ? response.data.data.object_path : prev.sbg,
          sbg_2: type === "sbg_2" ? response.data.data.object_path : prev.sbg_2,
          ktpPenerima:
            type === "ktpPenerima"
              ? response.data.data.object_path
              : prev.ktpPenerima,
          ktpNasabah:
            type === "ktpNasabah"
              ? response.data.data.object_path
              : prev.ktpNasabah,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const handleImageChange =
    (type) =>
    ({ fileList }) => {
      let tempFileList = [...fileList];
      tempFileList = tempFileList.slice(-1);

      tempFileList = tempFileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      if (type === "sbg") {
        setSbgImg(tempFileList);
      } else if (type === "ktpNasabah") {
        setktpNasabahImg(tempFileList);
      } else if (type === "ktpPenerima") {
        setktpPenerimaImg(tempFileList);
      } else if (type === "sbg_2") {
        setSbgImg2(tempFileList);
      }
      if (errors[type]) {
        setErrors((prev) => ({
          ...prev,
          [type]: null,
        }));
      }
    };

  const handleAdd = () => {
    const newErrors = validate(addData);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const data = {
        gadai_id: addData.gadai_id,
        sbg: addData.sbg,
        sbg_2: addData.sbg_2,
        customer_ktp: !addData.ktpPenerima
          ? addData.ktpNasabah
          : addData.ktpPenerima,
        receiver_ktp: addData.ktpNasabah,
      };

      let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delivery/mark-done`;

      AxiosCustomPost(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Berhasil menambahkan transaksi",
          });
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal menambahkan transaksi: ${error.response.data.error.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setModalDetail(false);
          setAddData(addPengembalianData);
          setktpNasabahImg([]);
          setktpPenerimaImg([]);
          setSbgImg([]);
          setSbgImg2([]);
          getData();
        }
      );
    }
  };

  const validate = (data) => {
    const newErrors = {};

    if (!data.sbg || data.sbg === "") {
      newErrors.sbg = "SBG harus diupload";
    }
    if (!data.sbg_2 || data.sbg_2 === "") {
      newErrors.sbg_2 = "SBG 2 harus diupload";
    }
    if (!data.ktpNasabah || data.ktpNasabah === "") {
      newErrors.ktpNasabah = "Ktp Nasabah harus diupload";
    }
    return newErrors;
  };

  const handleUbah = (record) => {
    setModalUbah(true);
    setId(record.kode_gadai);
    setAlamatKirim(record.alamat);
    setKurir(record.kode_kurir);
    setOutletName(record.lokasi);
    setDate(new Date(record.tanggal_kirim_proses));
  };

  const handleEdit = (record) => {
    setModalAdd(true);
    setCodeGadai(record.kode_gadai);
    setNamaNasabah(record.nama_nasabah);
    setNotelpNasabah(record.no_telp_nasabah);
    setBarangJaminan(record.barang_jaminan);
    setWaktuKirim(record.waktu_kirim);
    setAlamatKirim(record.lokasi_kirim);
    setKurir(record.nama_kurir);
    setTanggalKirim(record.tanggal_kirim_detail);
    setktpNasabahImg(record.ktp_nasabah);
    setSbgImg(record.sbg);
    setktpPenerimaImg(record.ktp_penerima);
    setKondisi();
    setNoImei();
  };
  const handleDetail = (record) => {
    setModalDetail(true);
    setCodeGadai(record.kode_gadai);
    setSbg(record.no_sbg);
    setNamaNasabah(record.nama_nasabah);
    setNotelpNasabah(record.no_telp_nasabah);
    setBarangJaminan(record.barang_jaminan);
    setWaktuKirim(record.waktu_kirim);
    setAlamatKirim(record.lokasi_kirim);
    setKurir(record.nama_kurir);
    setTanggalKirim(record.tanggal_kirim_detail);
    setAddData((prev) => ({
      ...prev,
      gadai_id: record.kode_gadai,
    }));
    setKondisi(record.notes);
    setNoImei(record.imei);
  };

  const handleCloseModal = () => {
    // setSubmitting(false);
    setModalEditUser(false);
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
    }));
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: parseInt(value),
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  const handleSelectKurir = (e) => {
    setKurir({
      id: e.value,
      outlet: e.outlet,
    });
  };

  return (
    <>
      <div>
        <div className="p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Title text="Pengembalian Barang Terjadwal" />
              <Breadcrumb current="Pengembalian Barang Terjadwal" />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 200,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{totalRecords}</span> jadwal
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 mt-2">
            <div className="col-1 pl-0">
              <div>Tampilkan</div>
              <input
                type="number"
                name="pageSize"
                className="form-control border-97A0AE mt-1"
                value={filterInput.pageSize}
                min="1"
                onChange={handleFilterChanged}
              />
            </div>
            <div className="mr-3">
              <div>No. SBG/No. Kwitansi / Nama Nasabah</div>
              <input
                type="text"
                name="name"
                className="form-control border-97A0AE mt-1"
                placeholder="Cari.."
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div>
              <CustomDatePicker
                id={"TanggalJemput"}
                label={"Tanggal Kirim"}
                isRangePicker
                width="60%"
                onInputChange={handleDateChange}
                value={dateValue}
                height="35px"
              />
            </div>
          </div>
          <div className="mt-3">
            <CustomTable
              columns={renderColumns(handleEdit, handleDetail, handleUbah)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
              scrollX={2000}
            />
          </div>
        </div>
      </div>

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />

      {/* Batalkan Proses Gadai */}
      <Modal
        centered
        className="modal-form"
        title="Batalkan Proses Gadai"
        visible={modalCancel}
        onCancel={() => {
          setModalCancel(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalCancel(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            onClick={() => {
              setModalCancel(true);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "red",
            }}
          >
            Batalkan
          </Button>,
        ]}
      >
        <div>
          <form>
            <div className="form-group">
              <label>Berikan Alasan :</label>
              <textarea className="form-control" rows="5"></textarea>
            </div>
          </form>
        </div>
      </Modal>

      {/* Konfirmasi Pengambilang Barang */}
      <Modal
        className="modal-form"
        centered
        title="Tandai Selesai"
        visible={modalDetail}
        onCancel={() => {
          setModalDetail(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalDetail(false);
              reset();
            }}
            style={{
              border: "0.75px solid #2C465C",
              borderRadius: 6,
              width: 120,
              height: 35,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleAdd}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 150,
              height: 35,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Tambah
          </Button>,
        ]}
      >
        <div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">No. SBG</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {sbg}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Nama Nasabah</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {namaNasabah}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">No. Telepon Nasabah</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {notelpNasabah}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Barang Jaminan</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {convertBarangJaminan(barangJaminan)}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Kondisi</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {kondisi}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Tanggal Jemput </label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {tanggalKirim}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Waktu Jemput </label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {waktuKirim}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Alamat Jemput</label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {alamatKirim}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-5">
              <label className="color-A6A6A6">Kurir </label>
            </div>
            <div className="col-7">
              <p className="ml-auto">: {kurir}</p>
            </div>
          </div>
          <AddUpload
            onImageChange={handleImageChange}
            handleUploadImage={handleUploadImage}
            sbgImg={sbgImg}
            sbgImg2={sbgImg2}
            ktpNasabahImg={ktpNasabahImg}
            ktpPenerimaImg={ktpPenerimaImg}
          />
          <ErrorDiv errors={errors} />
        </div>
      </Modal>

      {/* Ubah Jadwal  */}
      <Modal
        className="modal-form"
        centered
        title="Ubah Jadwal"
        visible={modalUbah}
        onCancel={() => {
          setModalUbah(false);
        }}
        footer={[
          <Button
            onClick={() => {
              setModalCancel(true);
              setModalUbah(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "red",
            }}
          >
            Batalkan
          </Button>,
          <Button
            onClick={() => {
              setModalUbah(false);
              reset();
            }}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Kirirm
          </Button>,
        ]}
      >
        <div>
          <form>
            <div className="row form-group align-items-center">
              <div className="col-4">
                <label>Tanggal Kirim :</label>
              </div>
              <div className="col-8">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={date}
                  onChange={(date) => setDate(date)}
                  className="form-control"
                />
              </div>
              <IoCalendarOutline
                style={{ fontSize: 20, marginLeft: -50, zIndex: 1 }}
              />
            </div>
            <div className="row form-group align-items-center">
              <div className="col-4">
                <label>Waktu Kirim :</label>
              </div>
              <div className="col-8">
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="HH:mm"
                  className="form-control"
                />
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Alamat :</label>
              </div>
              <div className="col-8">
                <Input.TextArea
                  required
                  rows="6"
                  type="text"
                  className="form-control border-DCDCDC text-input"
                  placeholder="Alamat outlet"
                  defaultValue={alamatKirim}
                  value={alamatKirim}
                  onChange={(e) => setAlamatKirim(e.target.value)}
                />
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Kurir :</label>
              </div>
              <div className="col-8">
                <div style={{ flex: 2 }}>
                  <Select
                    name="kurir"
                    options={kurirList}
                    onChange={(e) => handleSelectKurir(e)}
                    value={kurirList.find((e) => e.value == kurir?.id) || ""}
                  />
                </div>
              </div>
            </div>
            <div className="row form-group align-items-start">
              <div className="col-4">
                <label>Outlet :</label>
              </div>
              <div className="col-8">
                <p>{kurir?.outlet || "-"}</p>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
}

const convertBarangJaminan = (barangJaminan) => {
  if (barangJaminan == "bike") {
    return "Sepeda Motor";
  } else if (barangJaminan == "car") {
    return "Mobile";
  } else if (barangJaminan == "smartphone") {
    return "Smartphone";
  } else if (barangJaminan == "bpkb") {
    return "BPKB";
  }
};
